/**
 * addReceiver(key, cb) // 广播监听
 * removeReceiver(key) // 移除监听
 * broadcast(key, value1, value2) // 发送广播
 */
import { isInnerYueyue, YYApp } from "./tool";

export default {
  broadcast(key, ...arg) {
    if (!isInnerYueyue() && !key) {
      return;
    }
    window.AmapApp.bridge.send({
      action: "broadcast",
      key,
      value: [...arg],
    });
  },

  addReceiver(key, cb) {
    // if (!isInnerYueyue() && (!key || !cb)) {
    //   return;
    // }
    window.AmapApp.bridge.send(
      {
        action: "receiver",
        key,
        intent: "addReceiver",
        needHold: true,
      },
      (res) => {
        console.log("broadcast:res_____", res);
        let value = [];
        try {
          if (res && typeof res === "string") {
            res = JSON.parse(res);
          }
          if (res && res.value) {
            if (typeof res.value === "string") {
              value = JSON.parse(res.value);
            } else {
              value = res.value;
            }
          }
        } catch (error) {
          value = [];
          console.log("addReceiver:error_______", error);
        }
        cb(...value);
      }
    );
  },

  removeReceiver(key) {
    if (!isInnerYueyue() && !key) {
      return;
    }
    window.YYApp.bridge({
      action: "receiver",
      key,
      intent: "removeReceiver",
    });
  },
};
